// PermitsInfoModal.js
import { Modal, ModalHeader, ModalBody, ModalContent } from "@heroui/react";
import { useEffect } from "react";
import PermitInfoComponent from "./permitsInfoComponent";

const PermitsInfoModal = ({ isOpen, onClose, unit, building }: any) => {
  useEffect(() => {
    console.log("Building:", building);
    console.log("Unit:", unit);
  }, [building, unit]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="5xl"
      shouldBlockScroll={true}
      isDismissable={true}
      scrollBehavior="inside"
      backdrop="blur"
      className="p-8"
    >
      <ModalContent className="flex flex-col gap-4 font-normal text-neutral-primary">
        <ModalHeader className="flex flex-row items-center justify-between p-0 font-normal">
          <p>{unit?.id || building?.id} - Vergunningen</p>
        </ModalHeader>
        <ModalBody className="px-0">
          <PermitInfoComponent
            handleCloseParent={onClose}
            buildingRegulatoryInfo={
              unit
                ? {
                  ...unit?.regulatoryInfo,
                  unitId: unit?.id,
                }
              : {
                  ...building?.regulatoryInfo,
                  buildingId: building?.id,
                }
            }
            unit={unit}
            building={building}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PermitsInfoModal;
